<template>
  <div class="manageCardList">
    <div class="filters">
      <!-- 卡片搜索 -->
      <el-form class="leftSearch" :inline="true">
        <!-- 卡号 -->
        <el-form-item>
          <el-input class="seachInput" v-model="cardNum" :placeholder="$t('lang.lbl_fkgl_cardNum')"></el-input>
        </el-form-item>
        <!-- 姓名 -->
        <el-form-item>
          <el-input class="seachInput" v-model="userName" :placeholder="$t('lang.lbl_fkgl_userName')"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item>
          <el-input class="seachInput" v-model="mobile" :placeholder="$t('lang.lbl_fkgl_mobile')"></el-input>
        </el-form-item>
        <!-- 人员类型 -->
        <el-form-item>
          <el-select class="select" v-model="department" :placeholder="$t('lang.CARDTYPE.TYPE[0].label')">
            <el-option v-for="item in departmentList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择园区 -->
        <el-form-item>
          <el-select class="select" v-model="gardenId" @change="selectHouse" disabled>
            <el-option key :label="$t('lang.lab_selectVillage')" value="0"></el-option>
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择楼号 -->
        <el-form-item>
          <el-select class="select" v-model="houseId" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value="0"></el-option>
            <el-option v-for="(item,index) in houseList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择单元号 -->
        <el-form-item>
          <el-select v-model="unitId" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value="0"></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择房间号 -->
        <el-form-item>
          <el-select v-model="roomId">
            <el-option key :label="$t('lang.lab_roomName')" value="0"></el-option>
            <el-option v-for="(item,index) in roomList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <br>
        <!-- 通行设备 -->
        <el-form-item>
          <el-select class="select" multiple collapse-tags v-model="searchDevice"
            :placeholder="$t('lang.lbl_fkgl_goDeviceSelect')">
            <el-option v-for="item in deviceList" :key="item.id" :label="item.eqName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 通行楼层 -->
        <el-form-item>
          <el-select class="select" multiple collapse-tags v-model="searchFloor"
            :placeholder="$t('lang.lbl_fkgl_goFloorSelect')">
            <el-option v-for="item in passFloorList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 卡类型 -->
        <el-form-item>
          <el-select class="select" v-model="cardType" :placeholder="$t('lang.CARDTYPE.TYPE[0].label')">
            <el-option v-for="item in cardTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 卡状态 -->
        <!-- <el-form-item>
          <el-select class="select" v-model="cardStatus" :placeholder="$t('lang.CARDSTATUS.STATUS[0].label')">
            <el-option v-for="item in cardStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 卡有效期限 -->
        <el-form-item>
          <div class="block">
            <el-date-picker v-model="cardValidityDate" type="date" value-format="timestamp" placeholder="卡有效期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-button type="warning" @click="reset()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="commit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
      <!-- 卡片操作 -->
      <el-form class="rightBtn">
        <el-button type="primary" @click="readCard" :disabled="!message">{{$t('lang.lbl_fkgl_readCard')}}</el-button>
        <el-button type="primary" @click="dialogVisible = true" :disabled="!(selectedRow&&message)">
          {{$t('lang.lbl_fkgl_writeCard')}}</el-button>
        <el-button type="primary" @click="initCard" :disabled="!message">{{$t('lang.lbl_fkgl_initialCard')}}</el-button>
        <el-button type="primary" @click="getCardId('reset')" :disabled="!message">{{$t('lang.lbl_fkgl_resetCard')}}
        </el-button>
        <el-button type="primary" @click="showAbilityCard = true" :disabled="!message">
          {{$t('lang.lbl_fkgl_abilityCard')}}</el-button>
        <el-button type="primary" @click="showTool = true" :disabled="!message">工具</el-button>
        <el-button type="primary" @click="getEdition" :disabled="!message">发卡器版本</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.lbl_fkgl_addCard')}}</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        @row-click='rowClick' class="wid100" :row-class-name="tableRowClassName" :row-style="selectedstyle"
        style="width: 100%">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="userName" :label="$t('lang.lbl_fkgl_userName')">
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lbl_fkgl_mobile')" width="120px">
        </el-table-column>
        <el-table-column prop="department" :label="$t('lang.lbl_fkgl_peopleType')" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.department == ''">--</span>
            <span v-if="scope.row.department == 1">{{departmentList[1].label}}</span>
            <span v-if="scope.row.department == 2">{{departmentList[2].label}}</span>
            <span v-if="scope.row.department == 3">{{departmentList[3].label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="houseName" :label="$t('lang.lbl_fkgl_house')">
        </el-table-column>
        <el-table-column prop="unitName" :label="$t('lang.lbl_fkgl_unit')">
        </el-table-column>
        <el-table-column prop="roomName" :label="$t('lang.lbl_fkgl_room')">
        </el-table-column>
        <el-table-column prop="cardNumber" :label="$t('lang.lbl_fkgl_cardNum')" width="120px">
        </el-table-column>
        <el-table-column prop="cardType" :label="$t('lang.lbl_fkgl_cardType1')">
          <template slot-scope="scope">
            <span v-if="scope.row.cardType == 0">--</span>
            <span v-if="scope.row.cardType == 1">{{cardTypeList[1].label}}</span>
            <!-- <span v-if="scope.row.cardType == 2">{{cardTypeList[2].label}}</span> -->
            <span v-if="scope.row.cardType == 3">{{cardTypeList[3].label}}</span>
            <!-- <span v-if="scope.row.cardType == 4">{{cardTypeList[3].label}}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="eqName" :label="$t('lang.lbl_fkgl_goDevice')" width="200px">
        </el-table-column>
        <el-table-column prop="floor" :label="$t('lang.lbl_fkgl_goFloor')" width="200px">
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('lang.lbl_fkgl_cardExpirationTime')" sortable width="200px">
          <template slot-scope="scope">
            {{ scope.row.endTime | time }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="beforeWriteTime" :label="$t('lang.lbl_fkgl_cardWriteLastTime')" sortable width="200px">
          <template slot-scope="scope">
            {{ scope.row.beforeWriteTime | time }}
          </template>
        </el-table-column> -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" width="160px">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button v-if='scope.row.isReportLoss==0' @click="reportLoss(scope.row)">{{$t('lang.btn_loss')}}
            </el-button>
            <el-button v-if='scope.row.isReportLoss==1' @click="cencelLoss(scope.row)">{{$t('lang.btn_losscel')}}
            </el-button>
            <el-button v-if='!(scope.row.cardNumber)' class="orange" @click="deleteOne(scope.row.id)">
              {{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 写卡弹窗 -->
    <el-dialog title="写卡" :visible.sync="dialogVisible" width="30%">
      <p>编号：<span>{{writeCardDate.num}}</span></p>
      <p>姓名：<span>{{writeCardDate.name}}</span></p>
      <p>住址：<span>{{writeCardDate.address}}</span></p>
      <p>卡号：<span>{{writeCardDate.cardNum}}</span></p>
      <p>过期时间：<span>{{writeCardDate.endTs}}</span></p>
      <p>通行设备：<span>{{writeCardDate.device}}</span></p>
      <p>通行楼层：<span>{{writeCardDate.floor}}</span></p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getCardId('write')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 工具弹窗 -->
    <el-dialog title="工具" :visible.sync="showTool" width="30%">
      <p>修改发卡器使用扇区号（范围2-15，修改此项，管理卡也需要重新写卡）</p>
      <el-input v-model="sectorNum" placeholder="请输入扇区号（范围2-15）" class="item-input" style="width:50%"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="readSectorNum()">读 取</el-button>
        <el-button type="primary" @click="editSectorNum()">修 改</el-button>
      </span>
    </el-dialog>
    <!-- 功能卡弹窗 -->
    <el-dialog title="功能卡" :visible.sync="showAbilityCard" width="30%">
      <el-radio-group v-model="abilityCardRadio">
        <div>
          <el-radio :label="1">校时卡</el-radio>
          <el-radio :label="2">关闭卡</el-radio>
          <el-radio :label="3">启用卡</el-radio>
        </div>
        <br>
        <div style="margin-top:15px">
          <el-radio :label="4">管理卡</el-radio>
          <!-- <el-radio :label="5">地址卡</el-radio> -->
          <el-radio :label="6">挂失卡/解挂失卡</el-radio>
        </div>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAbility()">取 消</el-button>
        <el-button type="primary" @click="configAbility()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 功能卡详情弹窗 -->
    <el-dialog :title="abilityCardTitle" :visible.sync="showAbilityCardDetail" width="40%">
      <!-- 管理卡 -->
      <el-form v-if='abilityCardRadio==4' ref="form" :model="form" label-width="80px">
        <el-form-item label="扇区号">
          <el-input v-model="form.abilityCardSectorNum" placeholder="请输入卡的扇区号（范围2-15）"></el-input>
        </el-form-item>
        <el-form-item label="设备号">
          <el-input v-model="form.abilityCardDeviceNum" placeholder="请输入设备号（范围1-255）"></el-input>
        </el-form-item>
      </el-form>
      <!-- 启用卡 -->
      <el-form v-if='abilityCardRadio==3' ref="form" :model="form" label-width="80px">
        <p>在设备读头上刷此卡，开启设备的刷卡功能，用户必须刷卡才能乘梯</p>
        <p class="tips">注意：关闭卡和启用卡各做一张即可，如果卡片丢失，做一个新卡，在读头上刷，以前的卡片都拉黑</p>
      </el-form>
      <!-- 关闭卡 -->
      <el-form class="closeCardDetail" v-if='abilityCardRadio==2' ref="form" :model="form" label-width="80px">
        <p>在设备读头上刷此卡，分时段关闭设备的刷卡功能</p>
        <el-form-item label="星期：">
          <el-checkbox-group v-model="form.closeWeekList">
            <el-checkbox label="1">周一</el-checkbox>
            <el-checkbox label="2">周二</el-checkbox>
            <el-checkbox label="3">周三</el-checkbox>
            <el-checkbox label="4">周四</el-checkbox>
            <el-checkbox label="5">周五</el-checkbox>
            <el-checkbox label="6">周六</el-checkbox>
            <el-checkbox label="7">周日</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="时间1：">
          <span>开始时间：</span>
          <el-input v-model="form.startHour1" @input="maxHour($event,1,'start')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">时</span>
          <el-input v-model="form.startMinute1" @input="maxMinute($event,1,'start')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">分</span>
          <span class="ml-30">结束时间：</span>
          <el-input v-model="form.endHour1" @input="maxHour($event,1,'end')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">时</span>
          <el-input v-model="form.endMinute1" @input="maxMinute($event,1,'end')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">分</span>
        </el-form-item>
        <el-form-item label="时间2：">
          <span>开始时间：</span>
          <el-input v-model="form.startHour2" @input="maxHour($event,2,'start')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">时</span>
          <el-input v-model="form.startMinute2" @input="maxMinute($event,2,'start')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">分</span>
          <span class="ml-30">结束时间：</span>
          <el-input v-model="form.endHour2" @input="maxHour($event,2,'end')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">时</span>
          <el-input v-model="form.endMinute2" @input="maxMinute($event,2,'end')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">分</span>
        </el-form-item>
        <el-form-item label="时间3：">
          <span>开始时间：</span>
          <el-input v-model="form.startHour3" @input="maxHour($event,3,'start')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">时</span>
          <el-input v-model="form.startMinute3" @input="maxMinute($event,3,'start')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">分</span>
          <span class="ml-30">结束时间：</span>
          <el-input v-model="form.endHour3" @input="maxHour($event,3,'end')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">时</span>
          <el-input v-model="form.endMinute3" @input="maxMinute($event,3,'end')" maxlength='2' label-width="100px">
          </el-input>
          <span class="company">分</span>
        </el-form-item>
        <p class="tips">注意：关闭卡和启用卡各做一张即可，如果卡片丢失，做一个新卡，在读头上刷，以前的卡片都拉黑</p>
      </el-form>
      <!-- 校时卡 -->
      <el-form class="timingCardDetail" v-if='abilityCardRadio==1' ref="form" :model="form" label-width="210px">
        <el-form-item label="设置控制器时间：">
          <el-date-picker v-model="form.setTiming" type="datetime" value-format="yyyy-MM-dd-HH-mm" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="设置公共楼层：" class="closeCardDetail">
          <span>楼层1：</span>
          <el-input v-model="form.publicFloor1" maxlength='2' label-width="100px">
          </el-input>
          <span class="ml-30">楼层2：</span>
          <el-input v-model="form.publicFloor2" maxlength='2' label-width="100px">
          </el-input>
          <span class="ml-30">楼层3：</span>
          <el-input v-model="form.publicFloor3" maxlength='2' max=64 label-width="100px">
          </el-input>
        </el-form-item>
        <el-form-item label="二维码有效次数（1-30）：" class="closeCardDetail1">
          <el-input v-model="form.ewmNum" maxlength='2' label-width="100px">
          </el-input>
          <span class="ml-30">次</span>
        </el-form-item>
        <el-form-item label="二维码开门时间（1-20）：" class="closeCardDetail1">
          <el-input v-model="form.ewmTime" maxlength='2' label-width="100px">
          </el-input>
          <span class="ml-30">秒</span>
        </el-form-item>
        <el-form-item label="访客联动有限时间（1-255）：" class="closeCardDetail1">
          <el-input v-model="form.peoTime" maxlength='3' label-width="120px">
          </el-input>
          <span class="ml-30">秒</span>
        </el-form-item>
      </el-form>
      <!-- 挂失、解挂失卡 -->
      <el-form v-if='abilityCardRadio==6' ref="form" :model="form" label-width="180px">
        <el-table ref="multipleTable" :data="form.lossTableData" :row-key="get_row_key" tooltip-effect="dark"
          style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="userName" :label="$t('lang.lbl_fkgl_userName')">
          </el-table-column>
          <el-table-column prop="cardNumber" :label="$t('lang.lbl_fkgl_cardNum')" width="120px">
          </el-table-column>
          <el-table-column prop="houseName" :label="$t('lang.lbl_fkgl_house')">
          </el-table-column>
          <el-table-column prop="unitName" :label="$t('lang.lbl_fkgl_unit')">
          </el-table-column>
          <el-table-column prop="roomName" :label="$t('lang.lbl_fkgl_room')">
          </el-table-column>
          <el-table-column prop="endTime" :label="$t('lang.lbl_fkgl_cardExpirationTime')" sortable width="200px">
            <template slot-scope="scope">
              {{ scope.row.endTime | time }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNo1"
          :page-sizes="[10, 20, 30, 50]" :page-size="pageSize1" layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount1" />
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelWriteAbility()">取 消</el-button>
        <el-button v-if="abilityCardRadio!=6" type="primary" @click="configWriteAbility()">写 卡</el-button>
        <el-button v-if="abilityCardRadio==6" type="primary" @click="configWriteLoss()">写挂失卡</el-button>
        <el-button v-if="abilityCardRadio==6" type="primary" @click="configWriteLossCel()">写解挂失卡</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  /**
   *@ClassName:manageCardList
   *@Description:发卡管理列表
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2021-09-01
   */

  export default {
    // name: '/manage/main.manageCardList',
    data() {
      return {
        sectorNum: '', // 设备扇区号
        cardUid: '', // 卡片id返回数据
        serialsNum: '', // 串口号（COM4）
        message: false,
        serial: this.createSerialHandler('ws://127.0.0.1:9528'),
        pageNum: 1,
        type: 1, // 楼号单元号房间号区分
        cardNum: '', // 卡号
        userName: '', // 姓名
        mobile: '', // 手机
        department: '', // 人员类型
        cardType: '', // 卡类型
        cardStatus: '', // 卡状态
        deviceList: [], // 通行设备列表
        cardValidityDate: '', // 卡有效期限
        gardenId: this.$store.getters.gardenId, // 小区绑定值
        gardens: [], // 小区下拉列表
        houseId: '0', // 楼号绑定值
        houseList: [], // 楼号下拉列表
        unitId: '0', // 单元绑定值
        unitList: [], // 单元下拉列表
        roomId: '0', // 房间绑定值
        roomList: [], // 房间下拉列表
        searchDevice: [], // 通行设备
        searchFloor: [], // 通行楼层
        departmentList: this.$i18n.t('lang.DEMPARTMENT.TYPE'), // 人员类型列表
        cardTypeList: this.$i18n.t('lang.CARDTYPE.TYPE'), // 卡类型列表
        cardStatusList: this.$i18n.t('lang.CARDSTATUS.STATUS'), // 卡状态列表
        passFloorList: this.$i18n.t('lang.PASSFLOOR.NUMBER'), // 通行楼层列表
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
        },
        tableData: [], // 卡列表
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        pageNo1: 1, // 挂失卡列表页数
        pageSize1: 10, // 挂失卡列表每页显示数量
        pageCount1: 0, // 挂失卡列表总页数
        dialogVisible: false, // 弹窗显示状态
        getIndex: '', // 点击行的index
        selectedRow: false, // 写卡按钮是否可以点击
        rowData: '', // 点击列表每行的数据
        writeCardDate: {
          num: '',
          name: '',
          address: '',
          cardNum: '',
          endTs: '',
          device: '',
          floor: ''
        },
        showTool: false, // 工具展示状态
        showAbilityCard: false, // 功能卡展示状态
        showAbilityCardDetail: false, // 功能卡详情展示状态
        abilityCardRadio: '', // 选择功能卡的类型
        abilityCardTitle: '', // 功能卡标题
        form: {
          abilityCardSectorNum: '', // 管理卡扇区号
          abilityCardDeviceNum: '', // 管理卡设备号
          closeWeekList: [], // 关闭卡星期
          startHour1: 0, // 关闭卡开始小时1
          startHour2: 0, // 关闭卡开始小时2
          startHour3: 0, // 关闭卡开始小时3
          startMinute1: 0, // 关闭卡开始分钟1
          startMinute2: 0, // 关闭卡开始分钟2
          startMinute3: 0, // 关闭卡开始分钟3
          endHour1: 0, // 关闭卡结束小时1
          endHour2: 0, // 关闭卡结束小时2
          endHour3: 0, // 关闭卡结束小时3
          endMinute1: 0, // 关闭卡结束分钟1
          endMinute2: 0, // 关闭卡结束分钟2
          endMinute3: 0, // 关闭卡结束分钟3
          setTiming: '', // 校时卡设置时间
          publicFloor1: 0, // 校时卡公共楼层1
          publicFloor2: 0, // 校时卡公共楼层2
          publicFloor3: 0, // 校时卡公共楼层3
          ewmNum: 0, // 校时卡二维码有效次数
          ewmTime: 0, // 校时卡二维码开门时间
          peoTime: 0, // 校时卡访客联动有效时间
          lossTableData: [], // 挂失、解挂失卡列表数据
          multipleSelection: [], // 选中的挂失、解挂失卡数据
        }, // 功能卡写卡数据
      }
    },
    // 初始化
    created() {
      let that = this
      this.getGArdens()
      this.selectHouse()
      this.getDevicelist()
      this.getData('')
      setTimeout(() => {
        that.serial.fdSerial(function (res) {
          console.log('查找按钮返回: ', res)
          that.serialsNum = res.serials
        })
      }, 500)
    },
    beforeDestroy() {
      this.serial.Close(function (res) {
        console.log('关闭返回: ', res)
      })
    },
    watch: {
      serialsNum: {
        handler(val, oldVal) {
          let that = this
          if (val != '') {
            that.serial.Open(val, 9600, function (res) {
              console.log(res)
              if (res.message == '打开串口成功') {
                that.message = true
              } else {
                that.message = false
                this.$message({
                  type: 'error',
                  message: '打开串口失败'
                })
              }
            })
          }
        },
        deep: true
      },
      abilityCardRadio(val) {
        if (val == 1) {
          this.abilityCardTitle = '校时卡'
        } else if (val == 2) {
          this.abilityCardTitle = '关闭卡'
        } else if (val == 3) {
          this.abilityCardTitle = '启用卡'
        } else if (val == 4) {
          this.abilityCardTitle = '管理卡'
        } else if (val == 5) {
          this.abilityCardTitle = '地址卡'
        } else if (val == 6) {
          this.abilityCardTitle = '挂失卡/解挂失卡'
        }
      }
    },
    methods: {
      createSerialHandler(url) {
        let that = this
        if ('WebSocket' in window) {
          var SerialHandler = {}
          SerialHandler._ws = new WebSocket(url)
          SerialHandler._ws.onopen = function () {
            console.log('websocket已连接')
          }

          SerialHandler._ws.onmessage = function (evt) {
            var msg = evt.data
            var obj = JSON.parse(msg)
            if (SerialHandler._localCallback) {
              SerialHandler._localCallback(obj)
              // SerialHandler._localCallback = null
            }
            if (obj && obj.type === 'data' && SerialHandler.message_func) {
              SerialHandler.message_func(obj.data)
            }
          }

          SerialHandler._ws.onclose = function () {
            that.message = false
            console.log('websocket已断开')
          }

          SerialHandler.EnumSerial = function (callback) {
            SerialHandler._localCallback = callback
            var obj = {}
            obj.type = 'enum'
            SerialHandler._sendObject(obj)
          }
          SerialHandler.fdSerial = function (callback) {
            SerialHandler._localCallback = callback
            var obj = {}
            obj.type = 'fd'
            SerialHandler._sendObject(obj)
          }

          SerialHandler.Open = function (name, baud, callback) {
            SerialHandler._localCallback = callback
            var obj = {}
            obj.type = 'open'
            obj.serial_name = name
            obj.serial_baud = baud
            SerialHandler._sendObject(obj)
          }

          SerialHandler.Close = function (callback) {
            SerialHandler._localCallback = callback
            var obj = {}
            obj.type = 'close'
            SerialHandler._sendObject(obj)
          }
          SerialHandler.Send = function (data, callback) {
            SerialHandler._localCallback = callback
            var obj = {}
            obj.type = 'send'
            obj.data = data
            SerialHandler._sendObject(obj)
          }

          SerialHandler._sendObject = function (obj) {
            var str = JSON.stringify(obj)
            SerialHandler._ws.send(str)
          }
          return SerialHandler
        }
        return null
      },
      // 字符串转16进制
      strToHexCharCode(str) {
        if (str === '') {
          return ''
        }
        var hexCharCode = []
        hexCharCode.push('0x')
        for (var i = 0; i < str.length; i++) {
          hexCharCode.push((str.charCodeAt(i)).toString(16))
        }
        console.log('hexCharCode:' + hexCharCode)
        return hexCharCode.join('')
      },
      // 16进制转字符串
      hexCharCodeToStr(hexCharCodeStr) {
        var trimedStr = hexCharCodeStr.trim()
        var rawStr =
          trimedStr.substr(0, 2).toLowerCase() === '0x' ?
          trimedStr.substr(2) :
          trimedStr
        console.log('trimedStr:' + trimedStr)
        var len = rawStr.length
        if (len % 2 !== 0) {
          alert('Illegal Format ASCII Code!')
          return ''
        }
        var curCharCode
        var resultStr = []
        for (var i = 0; i < len; i = i + 2) {
          curCharCode = parseInt(rawStr.substr(i, 2), 16) // ASCII Code Value
          resultStr.push(String.fromCharCode(curCharCode))
        }
        return resultStr.join('')
      },
      // 16进制转axcii码
      hexCharCodeToAscii(hexCharCodeStr) {
        var trimedStr = hexCharCodeStr.trim()
        var rawStr = trimedStr.substr(0, 2).toLowerCase() === '0x' ? trimedStr.substr(2) : trimedStr
        var len = rawStr.length
        if (len % 2 !== 0) {
          alert('存在非法字符!')
          return ''
        }
        var curCharCode
        var resultStr = []
        for (var i = 0; i < len; i = i + 2) {
          curCharCode = parseInt(rawStr.substr(i, 2), 16)
          resultStr.push(String.fromCharCode(curCharCode))
        }
        return resultStr.join('')
      },
      // 初始化卡
      initCard() {
        let that = this
        let data = '56AA01AE0100'
        let arr = []
        let result = []
        let resolveData = ''
        let timeout = 0
        new Promise((resolve, reject) => {
          timeout = setTimeout(function () {
            alert('连接超时，请重试')
          }, 3000)
          that.serial.Send(data, function (res) {
            if (res.data) {
              resolveData += res.data
              if (resolveData.length >= 128 && timeout < 3000) {
                resolve(resolveData)
              }
            }
          })
        }).then((res) => {
          console.log(res)
          clearTimeout(timeout)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          console.log(result)
          if (result[5] == '01') {
            this.$message({
              type: 'success',
              message: '初始化卡成功'
            })
            that.cardIdData = result[6] + result[7] + result[8] + result[9]
          }
          if (result[5] == '02') {
            this.$message({
              type: 'error',
              message: '初始化卡失败，区域内无卡'
            })
          }
          if (result[5] == '03') {
            this.$message({
              type: 'error',
              message: '初始化卡失败，非本系统卡片'
            })
          }
        })
      },
      // 获取发卡器版本号
      getEdition() {
        let that = this
        let data = '56AA01920100'
        let resolveData = ''
        new Promise((resolve, reject) => {
          that.serial.Send(data, function (res) {
            if (res.data) {
              resolveData += res.data
              resolve(resolveData)
            }
          })
        }).then((res) => {
          let result = []
          let str = ''
          let arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          str = (result.slice(5, 20)).join('')
          alert('发卡器版本号：' + that.hexCharCodeToAscii(str))
        })
      },
      // 获取卡片id
      getCardId(flag) {
        let that = this
        let data = '56AA01A40100'
        let arr = []
        let result = []
        let timeout = 0
        new Promise((resolve, reject) => {
          timeout = setTimeout(function () {
            alert('连接超时，请重试')
          }, 3000)
          that.serial.Send(data, function (res) {
            if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
              resolve(res.data)
            }
          })
        }).then((res) => {
          console.log(res)
          clearTimeout(timeout)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          console.log(result)
          if (result[5] == '01') {
            that.cardUid = result[6] + result[7] + result[8] + result[9]
            if (flag == 'write') {
              // 拿着卡片uid去数据库查，是否存在本uid
              // 如果存在，提示卡号已发行，如果不存在，进行写卡操作
              that.getDbWriteCardStatus(that.rowData)
            } else if (flag == 'reset') {
              setTimeout(() => {
                that.resetCard()
              }, 200)
            }
          } else if (result[5] == '02') {
            this.$message({
              type: 'error',
              message: '区域内无卡'
            })
          } else if (result[5] == '03') {
            this.$message({
              type: 'error',
              message: '非本系统卡片'
            })
          } else if (result[5] == '04') {
            this.$message({
              type: 'info',
              message: '此卡是空卡，请初始化卡片'
            })
          } else if (result[5] == '05') {
            this.$message({
              type: 'info',
              message: '此卡是管理卡'
            })
          } else {
            this.$message({
              type: 'error',
              message: '失败'
            })
          }
        })
      },
      // 读卡
      readCard() {
        let that = this
        let data = '56AA01A60100'
        let arr = []
        let result = []
        let resolveData = ''
        new Promise((resolve, reject) => {
          that.serial.Send(data, function (res) {
            console.log(res.data)
            if (res.data) {
              resolveData += res.data
              if (resolveData.length >= 128) {
                resolve(resolveData)
              }
            }
          })
        }).then((res) => {
          console.log('读卡信息：' + res)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          console.log(result)
          if (result[5] == '0A') {
            this.$message({
              type: 'error',
              message: '读卡失败，区域内无卡'
            })
          } else if (result[5] == '0B') {
            this.$message({
              type: 'error',
              message: '读卡失败，非本系统卡片'
            })
          } else if (result[5] == '0D') {
            this.$message({
              type: 'info',
              message: '此卡是原始卡，请先初始化卡片'
            })
          } else if (result[5] == '0E') {
            this.$message({
              type: 'info',
              message: '此卡是管理卡'
            })
          } else if (result[5] == '0C') {
            if (result[7] == 'FF') {
              this.$message({
                type: 'info',
                message: '此卡是空白卡'
              })
            } else if (result[7] == '05') {
              this.$message({
                type: 'info',
                message: '此卡是关闭卡'
              })
            } else if (result[7] == '06') {
              this.$message({
                type: 'info',
                message: '此卡是启用卡'
              })
            } else if (result[7] == '07') {
              this.$message({
                type: 'info',
                message: '此卡是挂失卡'
              })
            } else if (result[7] == '08') {
              this.$message({
                type: 'info',
                message: '此卡是解挂失卡'
              })
            } else if (result[7] == '09') {
              this.$message({
                type: 'info',
                message: '此卡是校时卡'
              })
            } else if (result[7] == '0A') {
              this.$message({
                type: 'info',
                message: '此卡是管理卡'
              })
            } else if (result[8] == '04' && result[7] != 'FF') {
              this.$message({
                type: 'success',
                message: '读卡成功'
              })
              that.cardUid = result[9] + result[10] + result[11] + result[12]
              that.getData(that.cardUid)
            }
          } else {
            this.$message({
              type: 'error',
              message: '失败'
            })
          }
        })
      },
      // 写卡
      writeCard() {
        let that = this
        let data = '56AA01A5'
        let allLen = 0 // 数据域总长度
        let decFloor = that.getOneLift(that.rowData.floor.split(','))
        let hexFloor = that.bytes2HexStr(decFloor) // 楼层号16进制
        let cardTypeLen = '01' // 卡类型长度
        let cardType = '' // 卡类型
        let cardNumLen = '04' // 卡uid长度
        let cardNum = that.cardUid // 卡uid
        let cardDeviceLen = (that.rowData.eqNum).split(',').length // 卡设备长度
        let cardDeviceLen16 = cardDeviceLen < 10 ? '0' + cardDeviceLen.toString(16) : ((cardDeviceLen - 0).toString(16)
          .length > 1 ? (cardDeviceLen - 0).toString(16) : '0' + (cardDeviceLen - 0).toString(16)) // 卡设备长度16进制
        let cardDevice = '' // 卡设备
        let cardFloorLen = '08' // 卡楼层长度
        let cardFloor = hexFloor // 卡楼层
        let cardOpenTimeLen = '01' // 卡开门时间长度
        let cardOpenTime = '03' // 卡开门时间
        let cardEndTimeLen = '04' // 卡有效期长度
        let cardEndTime = that.format2(that.rowData.endTime) // 卡有效期
        let cardCountLen = '02' // 卡记录次数长度
        let cardCount = '0000' // 记录次数
        allLen = (27 + (cardDeviceLen - 0)).toString(16)
        let deviceArr = (that.rowData.eqNum).split(',') // 卡设备号数组
        for (let i = 0; i < deviceArr.length; i++) {
          cardDevice += deviceArr[i] < 10 ? '0' + deviceArr[i].toString(16) : ((deviceArr[i] - 0).toString(
            16).length > 1 ? (deviceArr[i] - 0).toString(16) : '0' + (deviceArr[i] - 0).toString(16))
        }
        if (that.rowData.cardType == 1) {
          cardType = '01'
        } else if (that.rowData.cardType == 2) {
          cardType = '02'
        } else if (that.rowData.cardType == 3) {
          cardType = '03'
        } else if (that.rowData.cardType == 4) {
          cardType = '04'
        }

        data += allLen + cardTypeLen + cardType + cardNumLen + cardNum + cardDeviceLen16 + cardDevice + cardFloorLen +
          cardFloor +
          cardOpenTimeLen + cardOpenTime + cardEndTimeLen + cardEndTime + cardCountLen + cardCount
        console.log('写卡数据：' + data)
        console.log('数据域长度：' + allLen)
        console.log('卡片uid：' + that.cardUid)
        console.log('通行设备16进制id：' + cardDevice)
        console.log('通行楼层号16进制：' + hexFloor)
        console.log('卡片有效期16进制：' + cardEndTime)
        let arr = []
        let result = []
        let timeout = 0
        new Promise((resolve, reject) => {
          timeout = setTimeout(function () {
            alert('连接超时，请重试')
          }, 3000)
          that.serial.Send(data, function (res) {
            console.log(res)
            if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
              resolve(res.data)
            }
          })
        }).then((res) => {
          console.log(res)
          clearTimeout(timeout)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          console.log(result)
          if (result[5] == '01') {
            this.$message({
              type: 'success',
              message: '写卡成功'
            })
            // 请求接口，将卡片uid写进数据库 that.rowData
            this.dbWriteCard(that.rowData)
            this.dialogVisible = false
          } else if (result[5] == '02') {
            this.$message({
              type: 'error',
              message: '写卡失败，区域内无卡'
            })
          } else if (result[5] == '03') {
            this.$message({
              type: 'info',
              message: '写卡次数不足，请联系厂家授权'
            })
          } else if (result[5] == '04') {
            this.$message({
              type: 'error',
              message: '写卡失败，非本系统卡片'
            })
          } else {
            this.$message({
              type: 'error',
              message: '失败'
            })
          }
        })
      },
      // 清卡信息
      resetCard() {
        let that = this
        let data = '56AA01A70100'
        let arr = []
        let result = []
        let timeout = 0
        new Promise((resolve, reject) => {
          timeout = setTimeout(function () {
            alert('连接超时，请重试')
          }, 3000)
          that.serial.Send(data, function (res) {
            console.log(res)
            if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
              resolve(res.data)
            }
          })
        }).then((res) => {
          console.log(res)
          clearTimeout(timeout)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          console.log(result)
          if (result[5] == '01') {
            // 请求接口，清除数据库中关联信息
            let id = result[6] + result[7] + result[8] + result[9]
            this.$patch(`/xl/informationCard/` + id).then(res => {
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: '清卡成功'
                  })
                  this.getData('')
                }
              },
              error => {
                this.$message.error(error)
              })
          } else if (result[5] == '02') {
            this.$message({
              type: 'error',
              message: '清卡失败，区域内无卡'
            })
          } else if (result[5] == '03') {
            this.$message({
              type: 'error',
              message: '清卡失败，非本系统卡片'
            })
          } else if (result[5] == '04') {
            this.$message({
              type: 'info',
              message: '此卡是原始卡，请初始化卡片'
            })
          } else if (result[5] == '05') {
            this.$message({
              type: 'info',
              message: '此卡是管理卡，无法清卡操作'
            })
          } else {
            this.$message({
              type: 'error',
              message: '失败'
            })
          }
        })
      },
      // 时间戳转化日期
      add0(m) {
        return m < 10 ? '0' + m : m
      },
      format(shijianchuo) {
        var time = new Date(shijianchuo)
        var y = time.getFullYear()
        var m = time.getMonth() + 1
        var d = time.getDate()
        var h = time.getHours()
        var mm = time.getMinutes()
        var s = time.getSeconds()
        return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(
          s)
      },
      format1(shijianchuo) {
        var time = new Date(shijianchuo)
        var y = time.getFullYear().toString().substr(time.getFullYear().toString().length - 2, 2)
        var m = time.getMonth() + 1
        var d = time.getDate()
        var h = time.getHours()
        return y + this.add0(m) + this.add0(d) + this.add0(h)
      },
      format2(shijianchuo) {
        var time = new Date(shijianchuo)
        var y = time.getFullYear().toString().substr(time.getFullYear().toString().length - 2, 2)
        y = y < 10 ? '0' + y.toString(16) : ((y - 0).toString(16)
          .length > 1 ? (y - 0).toString(16) : '0' + (y - 0).toString(
            16))
        var m = time.getMonth() + 1
        m = m < 10 ? '0' + m.toString(16) : ((m - 0).toString(16)
          .length > 1 ? (m - 0).toString(16) : '0' + (m - 0).toString(
            16))
        var d = time.getDate()
        d = d < 10 ? '0' + d.toString(16) : ((d - 0).toString(16)
          .length > 1 ? (d - 0).toString(16) : '0' + (d - 0).toString(
            16))
        var h = time.getHours()
        h = h < 10 ? '0' + h.toString(16) : ((h - 0).toString(16)
          .length > 1 ? (h - 0).toString(16) : '0' + (h - 0).toString(
            16))
        return y + m + d + h
      },
      // 读取设备扇区号
      readSectorNum() {
        let that = this
        let data = '56AA01B00100'
        let arr = []
        let result = []
        let resolveData = ''
        let timeout = 0
        new Promise((resolve, reject) => {
          timeout = setTimeout(function () {
            alert('连接超时，请重试')
          }, 3000)
          that.serial.Send(data, function (res) {
            console.log(res.data)
            if (res.data) {
              resolveData += res.data
              if (resolveData.length >= 128) {
                resolve(resolveData)
              }
            }
          })
        }).then((res) => {
          clearTimeout(timeout)
          console.log('读取设备扇区号：' + res)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          that.sectorNum = result[5] > 10 ? result[5] : result[5].substr(result[5].length - 1, 1)
        })
      },
      // 修改设备扇区号
      editSectorNum() {
        let that = this
        let data = '56AA01AF01' + (that.sectorNum < 10 ? '0' + that.sectorNum : that.sectorNum)
        let arr = []
        let result = []
        let resolveData = ''
        let timeout = 0
        new Promise((resolve, reject) => {
          timeout = setTimeout(function () {
            alert('连接超时，请重试')
          }, 3000)
          that.serial.Send(data, function (res) {
            console.log(res.data)
            if (res.data) {
              resolveData += res.data
              if (resolveData.length >= 128) {
                resolve(resolveData)
              }
            }
          })
        }).then((res) => {
          clearTimeout(timeout)
          console.log('修改设备扇区号：' + res)
          arr = res.split('')
          for (var i = 0; i < arr.length; i += 2) {
            result.push((arr.slice(i, i + 2)).join(''))
          }
          console.log(arr)
          if (result[5] == '5A') {
            this.$message({
              type: 'success',
              message: '修改设备扇区号成功'
            })
          } else if (result[5] == 'A5') {
            this.$message({
              type: 'error',
              message: '修改失败，扇区号范围为 " 2 - 15 " '
            })
          }
        })
      },
      // 取消选择功能卡
      cancelAbility() {
        this.showAbilityCard = false
        this.abilityCardRadio = ''
      },
      // 确定选择功能卡
      configAbility() {
        if (this.abilityCardRadio == 4) {
          this.showAbilityCardDetail = true
          this.showAbilityCard = false
          // this.abilityCardRadio = ''
        } else if (this.abilityCardRadio == 1) {
          this.showAbilityCardDetail = true
          this.showAbilityCard = false
        } else if (this.abilityCardRadio == 2) {
          this.showAbilityCardDetail = true
          this.showAbilityCard = false
        } else if (this.abilityCardRadio == 3) {
          this.showAbilityCardDetail = true
          this.showAbilityCard = false
        } else if (this.abilityCardRadio == 6) {
          this.getLossData('')
          this.showAbilityCardDetail = true
          this.showAbilityCard = false
        } else {
          this.$message({
            type: 'info',
            message: '此功能暂未开放，敬请期待'
          })
        }
      },
      // 取消写功能卡
      cancelWriteAbility() {
        this.showAbilityCardDetail = false
      },
      // 确定写功能卡
      configWriteAbility() {
        let that = this
        let arr = []
        let result = []
        let timeout = 0
        // 校时卡
        if (that.abilityCardRadio == 1) {
          console.log(that.form)
          if (that.form.ewmNum > 30) {
            that.$message({
              type: 'error',
              message: '二维码有效次数为1-30'
            })
            return
          }
          if (that.form.ewmTime > 20) {
            that.$message({
              type: 'error',
              message: '二维码开门时间为1-30'
            })
            return
          }
          if (that.form.peoTime > 255) {
            that.$message({
              type: 'error',
              message: '校时卡访客联动有效时间为1-255'
            })
            return
          }
          if (that.form.setTiming) {
            let other = '0000'
            let ewmNum = that.form.ewmNum < 10 ? '0' + that.form.ewmNum.toString(16) : ((that.form
                .ewmNum - 0).toString(16)
              .length > 1 ? (that.form.ewmNum - 0).toString(16) : '0' + (that.form.ewmNum - 0).toString(
                16))
            let ewmTime = that.form.ewmTime < 10 ? '0' + that.form.ewmTime.toString(16) : ((that.form
                .ewmTime - 0).toString(16)
              .length > 1 ? (that.form.ewmTime - 0).toString(16) : '0' + (that.form.ewmTime - 0).toString(
                16))
            let peoTime = that.form.peoTime < 10 ? '0' + that.form.peoTime.toString(16) : ((that.form
                .peoTime - 0).toString(16)
              .length > 1 ? (that.form.peoTime - 0).toString(16) : '0' + (that.form.peoTime - 0).toString(
                16))
            other = other + ewmNum + ewmTime + peoTime
            let dateTime = that.form.setTiming.slice(2) // 日期时间
            dateTime = dateTime.split('-')
            let dateTime16 = ''
            for (let i = 0; i < dateTime.length; i++) {
              if ((dateTime[i] - 0).toString(16).length < 2) {
                let a = '0' + (dateTime[i] - 0).toString(16)
                dateTime16 += a
              } else {
                dateTime16 += (dateTime[i] - 0).toString(16)
              }
            }
            let floor1 = that.form.publicFloor1 < 10 ? '0' + that.form.publicFloor1.toString(16) : ((that.form
                .publicFloor1 - 0).toString(16)
              .length > 1 ? (that.form.publicFloor1 - 0).toString(16) : '0' + (that.form.publicFloor1 - 0).toString(
                16))
            let floor2 = that.form.publicFloor2 < 10 ? '0' + that.form.publicFloor2.toString(16) : ((that.form
                .publicFloor2 - 0).toString(16)
              .length > 1 ? (that.form.publicFloor2 - 0).toString(16) : '0' + (that.form.publicFloor2 - 0).toString(
                16))
            let floor3 = that.form.publicFloor3 < 10 ? '0' + that.form.publicFloor3.toString(16) : ((that.form
                .publicFloor3 - 0).toString(16)
              .length > 1 ? (that.form.publicFloor3 - 0).toString(16) : '0' + (that.form.publicFloor3 - 0).toString(
                16))
            let data = '56AA01A80D' + dateTime16 + floor1 + floor2 + floor3 + other
            console.log(data)
            new Promise((resolve, reject) => {
              timeout = setTimeout(function () {
                alert('连接超时，请重试')
              }, 3000)
              that.serial.Send(data, function (res) {
                console.log(res)
                if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
                  resolve(res.data)
                }
              })
            }).then((res) => {
              console.log(res)
              clearTimeout(timeout)
              arr = res.split('')
              for (var i = 0; i < arr.length; i += 2) {
                result.push((arr.slice(i, i + 2)).join(''))
              }
              console.log(result)
              if (result[5] == '01') {
                that.$message({
                  type: 'success',
                  message: '写校时卡成功'
                })
                that.abilityCardRadio = ''
                that.showAbilityCardDetail = false // 关闭弹窗
                that.form.setTiming = '' // 校时卡设置时间
                that.form.publicFloor1 = 0 // 校时卡公共楼层1
                that.form.publicFloor2 = 0 // 校时卡公共楼层2
                that.form.publicFloor3 = 0 // 校时卡公共楼层3
              } else if (result[5] == '02') {
                that.$message({
                  type: 'error',
                  message: '写校时卡失败，区域内无卡'
                })
              } else if (result[5] == '03') {
                that.$message({
                  type: 'error',
                  message: '写校时卡失败，非本系统卡片'
                })
              } else if (result[5] == '04') {
                that.$message({
                  type: 'info',
                  message: '此卡是原始卡，请先初始化卡片'
                })
              } else if (result[5] == '05') {
                that.$message({
                  type: 'info',
                  message: '此卡是管理卡'
                })
              } else {
                that.$message({
                  type: 'error',
                  message: '失败'
                })
              }
            })
          } else {
            that.$message({
              type: 'info',
              message: '请选择校正时间'
            })
          }
        }
        // 关闭卡
        if (that.abilityCardRadio == 2) {
          let randomNum = parseInt(Math.random() * (255 - 1 + 1) + 1).toString(16) // 随机数
          let decCloseWeek = that.getOneLift(that.form.closeWeekList) // 关闭卡星期10进制
          let hexCloseWeek = that.bytes2HexStr(decCloseWeek) // 关闭卡星期16进制
          hexCloseWeek = hexCloseWeek.substring(hexCloseWeek.length - 2, hexCloseWeek.length)
          let startHour1 = that.form.startHour1 == '0' ? '00' : (that.form.startHour1 < 10 ? '0' + that.form
            .startHour1 : that.form.startHour1)
          let startMinute1 = that.form.startMinute1 == '0' ? '00' : (that.form.startMinute1 < 10 ? '0' + that.form
            .startMinute1 : that.form.startMinute1)
          let startHour2 = that.form.startHour2 == '0' ? '00' : (that.form.startHour2 < 10 ? '0' + that.form
            .startHour2 : that.form.startHour2)
          let startMinute2 = that.form.startMinute2 == '0' ? '00' : (that.form.startMinute2 < 10 ? '0' + that.form
            .startMinute2 : that.form.startMinute2)
          let startHour3 = that.form.startHour3 == '0' ? '00' : (that.form.startHour3 < 10 ? '0' + that.form
            .startHour3 : that.form.startHour3)
          let startMinute3 = that.form.startMinute3 == '0' ? '00' : (that.form.startMinute3 < 10 ? '0' + that.form
            .startMinute3 : that.form.startMinute3)
          let endHour1 = that.form.endHour1 == '0' ? '00' : (that.form.endHour1 < 10 ? '0' + that.form.endHour1 : that
            .form.endHour1)
          let endMinute1 = that.form.endMinute1 == '0' ? '00' : (that.form.endMinute1 < 10 ? '0' + that.form
            .endMinute1 : that.form.endMinute1)
          let endHour2 = that.form.endHour2 == '0' ? '00' : (that.form.endHour2 < 10 ? '0' + that.form.endHour2 : that
            .form.endHour2)
          let endMinute2 = that.form.endMinute2 == '0' ? '00' : (that.form.endMinute2 < 10 ? '0' + that.form
            .endMinute2 : that.form.endMinute2)
          let endHour3 = that.form.endHour3 == '0' ? '00' : (that.form.endHour3 < 10 ? '0' + that.form.endHour3 : that
            .form.endHour3)
          let endMinute3 = that.form.endMinute3 == '0' ? '00' : (that.form.endMinute3 < 10 ? '0' + that.form
            .endMinute3 : that.form.endMinute3)
          // 结束时间不能早于开始时间
          if (startHour1 > endHour1) {
            this.$message({
              type: 'error',
              message: '结束时间不能早于开始时间'
            })
            return
          }
          if (startHour1 == endHour1 && startMinute1 > endMinute1) {
            this.$message({
              type: 'error',
              message: '结束时间不能早于开始时间'
            })
            return
          }
          if (startHour2 > endHour2) {
            this.$message({
              type: 'error',
              message: '结束时间不能早于开始时间'
            })
            return
          }
          if (startHour2 == endHour2 && startMinute2 > endMinute2) {
            this.$message({
              type: 'error',
              message: '结束时间不能早于开始时间'
            })
            return
          }
          if (startHour3 > endHour3) {
            this.$message({
              type: 'error',
              message: '结束时间不能早于开始时间'
            })
            return
          }
          if (startHour3 == endHour3 && startMinute3 > endMinute3) {
            this.$message({
              type: 'error',
              message: '结束时间不能早于开始时间'
            })
            return
          }
          let dateContent = startHour1 + startMinute1 + endHour1 + endMinute1 + startHour2 + startMinute2 + endHour2 +
            endMinute2 + startHour3 + startMinute3 + endHour3 + endMinute3 // 关闭时间段
          let data = '56AA01AC0E' + randomNum + hexCloseWeek + dateContent
          console.log(data)
          new Promise((resolve, reject) => {
            timeout = setTimeout(function () {
              alert('连接超时，请重试')
            }, 3000)
            that.serial.Send(data, function (res) {
              console.log(res)
              if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
                resolve(res.data)
              }
            })
          }).then((res) => {
            console.log(res)
            clearTimeout(timeout)
            arr = res.split('')
            for (var i = 0; i < arr.length; i += 2) {
              result.push((arr.slice(i, i + 2)).join(''))
            }
            console.log(result)
            if (result[5] == '01') {
              that.$message({
                type: 'success',
                message: '写关闭卡成功'
              })
              that.abilityCardRadio = ''
              that.showAbilityCardDetail = false // 关闭弹窗
              that.form.closeWeekList = [] // 关闭卡星期
              that.form.startHour1 = 0 // 关闭卡开始小时1
              that.form.startHour2 = 0 // 关闭卡开始小时2
              that.form.startHour3 = 0 // 关闭卡开始小时3
              that.form.startMinute1 = 0 // 关闭卡开始分钟1
              that.form.startMinute2 = 0 // 关闭卡开始分钟2
              that.form.startMinute3 = 0 // 关闭卡开始分钟3
              that.form.endHour1 = 0 // 关闭卡结束小时1
              that.form.endHour2 = 0 // 关闭卡结束小时2
              that.form.endHour3 = 0 // 关闭卡结束小时3
              that.form.endMinute1 = 0 // 关闭卡结束分钟1
              that.form.endMinute2 = 0 // 关闭卡结束分钟2
              that.form.endMinute3 = 0 // 关闭卡结束分钟3
            } else if (result[5] == '02') {
              that.$message({
                type: 'error',
                message: '写关闭卡失败，区域内无卡'
              })
            } else if (result[5] == '03') {
              that.$message({
                type: 'error',
                message: '写关闭卡失败，非本系统卡片'
              })
            } else if (result[5] == '04') {
              that.$message({
                type: 'info',
                message: '此卡是原始卡，请先初始化卡片'
              })
            } else if (result[5] == '05') {
              that.$message({
                type: 'info',
                message: '此卡是管理卡'
              })
            } else {
              that.$message({
                type: 'error',
                message: '失败'
              })
            }
          })
        }
        // 开启卡
        if (that.abilityCardRadio == 3) {
          let randomNum = parseInt(Math.random() * (255 - 1 + 1) + 1).toString(16)
          let data = '56AA01AD01' + randomNum
          new Promise((resolve, reject) => {
            timeout = setTimeout(function () {
              alert('连接超时，请重试')
            }, 3000)
            that.serial.Send(data, function (res) {
              console.log(res)
              if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
                resolve(res.data)
              }
            })
          }).then((res) => {
            console.log(res)
            clearTimeout(timeout)
            arr = res.split('')
            for (var i = 0; i < arr.length; i += 2) {
              result.push((arr.slice(i, i + 2)).join(''))
            }
            console.log(result)
            if (result[5] == '01') {
              that.$message({
                type: 'success',
                message: '写启用卡成功'
              })
              that.showAbilityCardDetail = false
            } else if (result[5] == '02') {
              that.$message({
                type: 'error',
                message: '写启用卡失败，区域内无卡'
              })
            } else if (result[5] == '03') {
              that.$message({
                type: 'error',
                message: '写启用卡失败，非本系统卡片'
              })
            } else if (result[5] == '04') {
              that.$message({
                type: 'info',
                message: '此卡是原始卡，请先初始化卡片'
              })
            } else if (result[5] == '05') {
              that.$message({
                type: 'info',
                message: '此卡是管理卡'
              })
            } else {
              that.$message({
                type: 'error',
                message: '失败'
              })
            }
          })
        }
        // 管理卡
        if (that.abilityCardRadio == 4) {
          if (that.form.abilityCardSectorNum > 15 || that.form.abilityCardSectorNum < 2) {
            that.$message({
              type: 'error',
              message: '扇区号范围为 " 2 - 15 " '
            })
            return
          } else if (that.form.abilityCardDeviceNum > 255 || that.form.abilityCardDeviceNum < 1) {
            that.$message({
              type: 'error',
              message: '设备号范围为 " 1 - 255 " '
            })
            return
          }
          let abilityCardSectorNum = that.form.abilityCardSectorNum < 10 ? '0' + that.form.abilityCardSectorNum : that
            .form.abilityCardSectorNum
          let abilityCardDeviceNum = ((that.form.abilityCardDeviceNum - 0).toString(16)).length > 1 ? (that.form
            .abilityCardDeviceNum - 0).toString(16) : '0' + (that.form.abilityCardDeviceNum - 0).toString(16)
          let data = '56AA01A902' + abilityCardSectorNum + abilityCardDeviceNum
          new Promise((resolve, reject) => {
            timeout = setTimeout(function () {
              alert('连接超时，请重试')
            }, 3000)
            that.serial.Send(data, function (res) {
              console.log(res)
              if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
                resolve(res.data)
              }
            })
          }).then((res) => {
            console.log(res)
            clearTimeout(timeout)
            arr = res.split('')
            for (var i = 0; i < arr.length; i += 2) {
              result.push((arr.slice(i, i + 2)).join(''))
            }
            console.log(result)
            if (result[5] == '01') {
              that.$message({
                type: 'success',
                message: '写管理卡成功'
              })
              // 清空管理卡扇区号、设备号
              that.form.abilityCardSectorNum = ''
              that.form.abilityCardDeviceNum = ''
              that.showAbilityCardDetail = false
              that.abilityCardRadio = ''
            } else if (result[5] == '02') {
              that.$message({
                type: 'error',
                message: '写管理卡失败，区域内无卡'
              })
            } else if (result[5] == '03') {
              that.$message({
                type: 'error',
                message: '写管理卡失败，非本系统卡片'
              })
            } else {
              that.$message({
                type: 'error',
                message: '失败'
              })
            }
          })
        }
      },
      // 确定写挂失卡
      configWriteLoss() {
        let that = this
        if (that.form.multipleSelection.length < 1) {
          that.$message({
            type: 'error',
            message: '请选择您要挂失的卡片'
          })
        } else if (that.form.multipleSelection.length > 10) {
          that.$message({
            type: 'error',
            message: '一张挂失卡最多写10个卡号，请分多次写入'
          })
        } else {
          let data = '56AA01AA'
          // 10进制数据域长度
          let dataLen = (4 - 0) + that.form.multipleSelection.length * 4
          // 16进制数据域长度
          let datalen16 = dataLen < 10 ? '0' + dataLen.toString(16) : ((dataLen - 0).toString(16)
            .length > 1 ? (dataLen - 0).toString(16) : '0' + (dataLen - 0).toString(16))
          let cardNum = (that.form.multipleSelection.map(item => item.cardNumber)).join('')
          data += datalen16 + '00010001' + cardNum
          console.log('写挂失卡数据：' + data)
          let arr = []
          let result = []
          let timeout = 0
          new Promise((resolve, reject) => {
            timeout = setTimeout(function () {
              alert('连接超时，请重试')
            }, 3000)
            that.serial.Send(data, function (res) {
              console.log(res)
              if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
                resolve(res.data)
              }
            })
          }).then((res) => {
            console.log(res)
            clearTimeout(timeout)
            arr = res.split('')
            for (var i = 0; i < arr.length; i += 2) {
              result.push((arr.slice(i, i + 2)).join(''))
            }
            console.log(result)
            if (result[5] == '01') {
              this.$message({
                type: 'success',
                message: '写挂失卡成功'
              })
              that.showAbilityCardDetail = false
              that.abilityCardRadio = ''
              this.form.multipleSelection = []
            } else if (result[5] == '02') {
              this.$message({
                type: 'error',
                message: '写卡失败，区域内无卡'
              })
            } else if (result[5] == '03') {
              this.$message({
                type: 'error',
                message: '写卡失败，非本系统卡片'
              })
            } else if (result[5] == 'F1') {
              this.$message({
                type: 'error',
                message: '接收数据错误，请重新发送'
              })
            } else {
              this.$message({
                type: 'error',
                message: '失败'
              })
            }
          })
        }
      },
      // 确定写解挂失卡
      configWriteLossCel() {
        let that = this
        if (that.form.multipleSelection.length < 1) {
          that.$message({
            type: 'error',
            message: '请选择您要取消挂失的卡片'
          })
        } else if (this.form.multipleSelection.length > 10) {
          this.$message({
            type: 'error',
            message: '一张解挂失卡最多写10个卡号，请分多次写入'
          })
        } else {
          let data = '56AA01AB'
          // 10进制数据域长度
          let dataLen = (4 - 0) + that.form.multipleSelection.length * 4
          // 16制数据域长度
          let datalen16 = dataLen < 10 ? '0' + dataLen.toString(16) : ((dataLen - 0).toString(16)
            .length > 1 ? (dataLen - 0).toString(16) : '0' + (dataLen - 0).toString(16))
          let cardNum = (that.form.multipleSelection.map(item => item.cardNumber)).join('')
          data += datalen16 + '00010001' + cardNum
          console.log('写解挂失卡数据：' + data)
          let arr = []
          let result = []
          let timeout = 0
          new Promise((resolve, reject) => {
            timeout = setTimeout(function () {
              alert('连接超时，请重试')
            }, 3000)
            that.serial.Send(data, function (res) {
              console.log(res)
              if (res.data.length >= 64 && timeout < 3000 && res.data.indexOf('56AA02') != -1) {
                resolve(res.data)
              }
            })
          }).then((res) => {
            console.log(res)
            clearTimeout(timeout)
            arr = res.split('')
            for (var i = 0; i < arr.length; i += 2) {
              result.push((arr.slice(i, i + 2)).join(''))
            }
            console.log(result)
            if (result[5] == '01') {
              this.$message({
                type: 'success',
                message: '写解挂失卡成功'
              })
              that.showAbilityCardDetail = false
              that.abilityCardRadio = ''
              this.form.multipleSelection = []
            } else if (result[5] == '02') {
              this.$message({
                type: 'error',
                message: '写卡失败，区域内无卡'
              })
            } else if (result[5] == '03') {
              this.$message({
                type: 'error',
                message: '写卡失败，非本系统卡片'
              })
            } else if (result[5] == 'F1') {
              this.$message({
                type: 'error',
                message: '接收数据错误，请重新发送'
              })
            } else {
              this.$message({
                type: 'error',
                message: '失败'
              })
            }
          })
        }
      },
      // 挂失卡、解挂失卡，翻页保证选中状态不变
      get_row_key(row) {
        return row.id
      },
      // 挂失、解挂失卡选中的数据
      handleSelectionChange(val) {
        this.form.multipleSelection = val
        // this.form.multipleSelection.push(val)
        // // 二维数组转一维数组
        // this.form.multipleSelection = [].concat.apply([], this.form.multipleSelection)
        // // 选中挂失卡数组去重
        // let deWeightThree = () => {
        //   let map = new Map()
        //   for (let item of this.form.multipleSelection) {
        //     if (!map.has(item.id)) {
        //       map.set(item.id, item)
        //     }
        //   }
        //   return [...map.values()]
        // }
        // let newArr3 = deWeightThree()
        // 选中挂失卡数据赋值
        // this.form.multipleSelection = newArr3
        console.log(this.form.multipleSelection)
      },
      // 关闭卡最大小时
      maxHour(value, num, state) {
        if (value.replace(/[^\d]/g, '') !== '') {
          if (Number(value.replace(/[^\d]/g, '')) > 23) {
            if (num == 1) {
              if (state == 'start') {
                this.form.startHour1 = 23
              } else if (state == 'end') {
                this.form.endHour1 = 23
              }
            } else if (num == 2) {
              if (state == 'start') {
                this.form.startHour2 = 23
              } else if (state == 'end') {
                this.form.endHour2 = 23
              }
            } else if (num == 3) {
              if (state == 'start') {
                this.form.startHour3 = 23
              } else if (state == 'end') {
                this.form.endHour3 = 23
              }
            }
          }
        }
      },
      // 关闭卡最大分钟
      maxMinute(value, num, state) {
        if (value.replace(/[^\d]/g, '') !== '') {
          if (Number(value.replace(/[^\d]/g, '')) > 59) {
            if (num == 1) {
              if (state == 'start') {
                this.form.startMinute1 = 59
              } else if (state == 'end') {
                this.form.endHour1 = 59
              }
            } else if (num == 2) {
              if (state == 'start') {
                this.form.startMinute2 = 59
              } else if (state == 'end') {
                this.form.endMinute2 = 59
              }
            } else if (num == 3) {
              if (state == 'start') {
                this.form.startMinute3 = 59
              } else if (state == 'end') {
                this.form.endMinute3 = 59
              }
            }
          }
        }
      },
      // 获取挂失列表数据
      getLossData(cardUid) {
        let loading = this.$loading()
        this.$get(
          `/xl/information?IsReportLoss=1&pageSize=${this.pageSize1}&pageNo=${this.pageNo1}`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode == 0) {
              this.form.lossTableData = res.list
              this.pageCount1 = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取园区列表
      getGArdens() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              // res.list.unshift({
              //   id: 0,
              //   name: '请选择小区'
              // })
              this.gardens = res.list
              console.log(res)
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过小区选择楼号
      selectHouse() {
        this.type = 1
        this.houseId = '0'
        this.unitId = '0'
        this.roomId = '0'
        this.unitList = []
        this.roomList = []
        this.houseList = []
        this.gardenGrids(this.gardenId)
      },
      // 通过楼号选择单元号
      selectUnit() {
        this.type = 2
        this.unitId = '0'
        this.roomId = '0'
        this.roomList = []
        this.unitList = []
        this.gardenGrids(this.houseId)
      },
      // 通过单元选择房间号
      selectRoom() {
        this.roomList = []
        this.type = 3
        this.roomid = '0'
        this.gardenGrids(this.unitId)
      },
      // 通过园区id查询楼号楼层房间号
      gardenGrids(gardenid) {
        if (gardenid == '0' || gardenid == '') {
          return
        }
        this.$get(
          `/gardenGrids?type=${this.type}&pageSize=999&pageNo=${this.pageNum}&parentId=${gardenid}`
        ).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.houseList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
              } else if (this.type === 3) {
                this.roomList = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通行设备列表
      getDevicelist() {
        let loading = this.$loading()
        this.$get(
          `/xl/equipment/?gardenId=${this.gardenId}&pageNo=1&pageSize=999`
        ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.deviceList = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取列表数据
      getData(cardUid) {
        let loading = this.$loading()
        this.$get(
          `/xl/information?cardNumber=${cardUid}&userName=${this.userName}&mobile=${this.mobile}&department=${this.department}&houseId=${this.houseId}&unitId=${this.unitId}&roomId=${this.roomId}&cardType=${this.cardType}&endTs=${this.cardValidityDate == null ? '' : this.cardValidityDate}&floor=${this.searchFloor.join(',')}&xlEquipmentId=${this.searchDevice.join(',')}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode == 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 查询
      commit() {
        this.pageNo = 1
        this.getData(this.cardNum)
      },
      // 清空
      reset() {
        this.type = 1
        this.cardNum = ''
        this.userName = ''
        this.department = ''
        this.mobile = ''
        this.cardType = ''
        this.cardStatus = ''
        this.cardValidityDate = ''
        this.searchFloor = []
        this.searchDevice = []
        this.gardenId = this.$store.getters.gardenId
        this.houseId = '0'
        this.unitId = '0'
        this.roomId = '0'
      },
      // 新增卡片
      add() {
        window.localStorage.setItem('manageCardForm', '')
        window.localStorage.setItem('manageCardSaveData', '')
        this.$router.push({
          name: 'manageCardAdd',
          query: {
            flag: false
          }
        })
      },
      // 修改卡片
      edit(row) {
        window.localStorage.setItem('manageCardForm', '')
        window.localStorage.setItem('manageCardSaveData', '')
        this.$router.push({
          name: 'manageCardAdd',
          query: {
            flag: true,
            object: row
          }
        })
      },
      // 挂失卡片
      reportLoss(row) {
        if (!row.cardNumber) {
          this.$message({
            type: 'info',
            message: '还未发卡，不能挂失'
          })
        } else {
          let loading = this.$loading()
          let params = {
            isReportLoss: 1
          }
          this.$patch(`/xl/information/` + row.id, params).then(
            res => {
              console.log(res)
              loading.close()
              if (res && res.errCode === 0) {
                row.isReportLoss = 1
                this.$message.success('挂失卡片成功')
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 取消挂失卡片
      cencelLoss(row) {
        let loading = this.$loading()
        let params = {
          isReportLoss: 0
        }
        this.$patch(`/xl/information/` + row.id, params).then(
          res => {
            console.log(res)
            loading.close()
            if (res && res.errCode === 0) {
              row.isReportLoss = 0
              this.$message.success('取消挂失卡片成功')
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            // 添加del的url
            this.$delete(`/xl/information/` + id).then(res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 表格每一行单击
      rowClick(row, event, column) {
        console.log(row)
        this.rowData = row
        this.writeCardDate.num = row.index + 1
        this.writeCardDate.name = row.userName
        if (row.gardenName) {
          this.writeCardDate.address = row.gardenName
        }
        if (row.houseName) {
          this.writeCardDate.address = row.gardenName + row.houseName + '号楼'
        }
        if (row.unitName) {
          this.writeCardDate.address = row.gardenName + row.houseName + '号楼' + row.unitName + '单元'
        }
        if (row.roomName) {
          this.writeCardDate.address = row.gardenName + row.houseName + '号楼' + row.unitName + '单元' + row.roomName + '房间'
        }

        this.writeCardDate.cardNum = row.cardNumber
        this.writeCardDate.endTs = this.format(row.endTime)
        this.writeCardDate.device = row.eqName
        this.writeCardDate.floor = row.floor
        this.selectedRow = true
        this.getIndex = row.index
      },
      // 数据库写卡
      dbWriteCard(data) {
        console.log(data)
        let params = {}
        params.xlInformationId = data.id
        params.cardNumber = this.cardUid
        params.userName = data.userName
        params.mobile = data.mobile
        params.address = this.writeCardDate.address
        params.xlEquipmentId = data.xlEquipmentId
        params.floor = data.floor
        params.endTs = data.endTime
        console.log(params)
        this.$post('xl/informationLog', params).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              this.getData('')
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取数据库是否可写卡状态
      getDbWriteCardStatus(data) {
        // 拿着卡片uid去数据库查，是否存在本uid
        // 如果存在，提示卡号已发行，如果不存在，进行写卡操作
        let params = {}
        params.cardNumber = this.cardUid
        this.$get('xl/informationByCardNumber/' + data.id, params).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              if (res.write == 1) {
                this.writeCard()
              } else {
                this.$message.error('该卡号已发行')
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取10进制楼层号
      getOneLift(floors) {
        var x2 = new Uint8Array(8)
        var hFloor = new Uint32Array(floors.filter(function (num) {
          return num > 32
        })).reduce(function (prev, cur) {
          return prev | 1 << cur - 33
        }, 0)
        var lFloor = new Uint32Array(floors.filter(function (num) {
          return num <= 32
        })).reduce(function (prev, cur) {
          return prev | 1 << cur - 1
        }, 0)
        for (var i = 0; i < 4; i++) {
          x2[i] = hFloor >> (3 - i) * 8 & 0xFF
          x2[i + 4] = lFloor >> (3 - i) * 8 & 0xFF
        }
        return x2
      },
      // 10进制转16进制
      bytes2HexStr(bytes) {
        var str = ''
        for (var i = 0; i < bytes.length; i++) {
          var tmp = bytes[i].toString(16)

          if (tmp.length == 1) {
            tmp = '0' + tmp
          }
          str += tmp
        }
        return str
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData('')
      },
      // 挂失卡列表翻页
      handleCurrentChange1(val) {
        this.pageNo1 = val
        this.getLossData('')
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData('')
      },
      // 切换挂失卡列表每页显示多少数据
      handleSizeChange1(val) {
        this.pageNo1 = 1
        this.pageSize1 = val
        this.getLossData('')
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        row.index = rowIndex
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      selectedstyle({
        row,
        rowIndex
      }) {
        if ((this.getIndex) === rowIndex) {
          return {
            'background-color': '#E0F2F7'
          }
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang='scss'>
  .manageCardList {
    .rightBtn {
      margin-top: 20px;
      padding-top: 10px;
      text-align: center;
      border-top: 1px dashed #ccc;
    }

    .el-table .cell {
      text-align: center;
    }

    .el-dialog .el-dialog__body {
      padding: 20px 50px !important;
    }

    .el-dialog .el-dialog__body p {
      padding: 10px 0;
      font-weight: bold;
    }

    .el-dialog .el-dialog__body span {
      font-weight: 400;
    }

    .el-dialog__title {
      font-weight: bold;
    }

    .el-table tbody tr:hover>td {
      background-color: #E0F2F7;
    }

    .closeCardDetail .el-input {
      width: 50px;
    }

    .closeCardDetail .el-input__inner {
      width: 50px;
    }

    .closeCardDetail .company {
      margin: 0 15px;
    }

    .closeCardDetail .ml-30 {
      margin-left: 30px;
    }

    .closeCardDetail1 .el-input {
      width: 150px;
    }

    .closeCardDetail1 .el-input__inner {
      width: 150px;
    }

    .closeCardDetail1 .ml-30 {
      margin-left: 10px;
    }

    .tips {
      font-size: 13px;
      color: #999;
    }
  }
</style>